(ns manage.video-rendering.queries
  (:require [common.url :as url]
            [common.url-template :as url-tpl]))

(defn get-render-jobs-url
  "Get URL for fetching render jobs with optional cursor pagination."
  ([url-context advertiser-id]
   (get-render-jobs-url url-context advertiser-id {}))
  ([url-context advertiser-id params]
   (url-tpl/render :api/video-rendering-jobs url-context
                   (assoc params :advertiser-id advertiser-id))))

(defn get-render-job-url
  "Get URL for fetching a specific render job by ID."
  [url-context job-id]
  (url-tpl/render :api/video-rendering-job (assoc url-context :job-id job-id)))

(defn create-render-job-url
  "Get URL for creating a new render job."
  [url-context]
  (url-tpl/render :api/video-rendering-jobs url-context))

(defn cancel-render-job-url
  "Get URL for cancelling a render job."
  [url-context job-id]
  (url-tpl/render :api/video-rendering-job (assoc url-context :job-id job-id)))

(defn get-templates-url
  "Get URL for fetching available video templates from advertiser-api with revisions embedded."
  ([url-context advertiser-id]
   (get-templates-url url-context advertiser-id {}))
  ([url-context advertiser-id params]
   (url-tpl/render :api/advertiser-templates url-context
                   (assoc params
                          :advertiser-id advertiser-id
                          :embed "[\"revisions\"]"))))

(defn get-render-profiles-url
  "Get URL for fetching available render profiles."
  [url-context]
  (url-tpl/render :api/video-rendering-render-profiles url-context))
